/* src/app/private/components/reports/ticket-report-list/ticket-report-list.component.scss */
/*# sourceMappingURL=ticket-report-list.component.css.map */
